import React from 'react'
import Hero from '../component/Hero'
import Intrests from '../component/Intrests'
import Services from '../component/Services'
import Projects from '../component/Projects'
import Stack from '../component/Stack'
import Socials from '../component/Socials'
import Faq from '../component/Faq'



const Home = () => {
  return (
    <div className='bg-[#171718]'>
     <Hero />
     <Intrests />
     <Projects />
      <Services />
     <Stack/>
     <Socials/>
     <Faq/>
    
 
 

    </div>
  )
}

export default Home
